module.exports = __webpack_public_path__ + "static/f68fa4c9-e6a2-4ac5-989e-c57cbef99f3e-77447f00803f14d8c2fbf001f16d436c.webp";